import React from "react";
import { ComponentTypeProvider } from "../componentTypes/context/ComponentTypeContext";
import { PartComponentTypeProvider } from "../partComponentTypes/context/PartComponentTypeContext";
import { PartStateProvider } from "../partState/context/PartsContext";
import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { VendorsProvider } from "../vendors/context/VendorsContext";
import { Parts } from "./PartsPage";
import { PartsProvider } from "./context/PartsContext";

const PartsPage = () => {
	return (
		<ComponentTypeProvider>
			<VendorsProvider>
				<RootTypeProvider>
					<PartComponentTypeProvider>
						<PartStateProvider>
							<PartsProvider>
								<Parts />
							</PartsProvider>
						</PartStateProvider>
					</PartComponentTypeProvider>
				</RootTypeProvider>
			</VendorsProvider>
		</ComponentTypeProvider>
	);
};

export default PartsPage;
